import { useState, useEffect, useReducer } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  IconButton,
  Button,
  Snackbar,
  Alert,
  FormControl,
  FormHelperText,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DeleteIcon from "@mui/icons-material/Delete";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import MaterialButton from "../../components/MaterialButton";
import MaterialSnackbar from "../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import MaterialSelect from "../../components/MasterSelect";

import { useUserDetails } from "../../context/auth";
import AddBoxIcon from "@mui/icons-material/AddBox";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";

import { City, Country, State } from "country-state-city";
import Swal from "sweetalert2";
import { useLoading } from "../../context/loading";
import { CompanyState, handlechange } from "./Statemanagement";

import ViewCompany from "./viewcompanydetails";
import { apicall } from "../Integration/apicall";
import { getcompany } from "./query";
import { useNavigate } from "react-router-dom";
import {
  addcompany,
  deletecompany,
  updatecompany,
  verifyifsc,
} from "./mutation";

const AddCompany = () => {
  const nav = useNavigate();
  const { AccessData } = useUserDetails();
  const [IFSCmessages, setIFSCmessages] = useState("");
  const [pagestatus, setpagestatus] = useState({
    edit: false,
    view: false,
    add: false,
  });
  const [state, dispatch] = useReducer(handlechange, CompanyState);
  console.log(state, "statedata");

  const { setCirleLoading } = useLoading();
  const [company, setcompany] = useState({});
  const [snackbar, setsnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  console.log(confirmationDialog, "cdialog");

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const ownershiptypes = [
    {
      value: "Sole Proprietorship",
      label: "Sole Proprietorship",
    },
    {
      value: "Partnership",
      label: "Partnership",
    },
    {
      value: "Limited Liability",
      label: "Limited Liability",
    },
    {
      value: "Corporate",
      label: "Corporate",
    },
    {
      value: "Cooperative",
      label: "Cooperative",
    },
  ];

  const salutions = [
    {
      value: "MR",
      label: "MR",
    },
    {
      value: "MS",
      label: "MS",
    },
  ];

  useEffect(() => {
    fetchcompany();
  }, []);

  const fetchcompany = async () => {
    try {
      const res = await apicall(getcompany);
      console.log(res.success, "resdataaa");

      let success = res.success;
      console.log(success, "succdata");

      let data = res.data.data.getCompany.company;
      console.log(data.length, "company data");

      let message = res.data.data.message;

      if (success) {
        console.log("inside if");
        if (data.length) {
          setpagestatus({
            edit: false,
            view: true,
            add: false,
          });

          setcompany(data[0]);
          const companydata = data[0];
          for (let [key, value] of Object.entries(companydata)) {
            if (key === "contactInfo") {
              value.forEach((info, index) => {
                dispatch({
                  value: { value: info?.salutation, label: info?.salutation },
                  field: "contactInfo",
                  index,
                  arrayfield: "salutation",
                });

                dispatch({
                  value: info?.name,
                  field: "contactInfo",
                  index,
                  arrayfield: "name",
                });

                dispatch({
                  value: info?.designation,
                  field: "contactInfo",
                  index,
                  arrayfield: "designation",
                });

                dispatch({
                  value: info?.phoneNumber,
                  field: "contactInfo",
                  index,
                  arrayfield: "phoneNumber",
                });

                dispatch({
                  value: info?.email,
                  field: "contactInfo",
                  index,
                  arrayfield: "email",
                });
                dispatch({
                  value: info?.id,
                  field: "contactInfo",
                  index,
                  arrayfield: "id",
                });
              });
            } else {
              if (
                key === "city" ||
                key === "state" ||
                key === "country" ||
                key === "ownershipType"
              ) {
                dispatch({
                  value: { value, label: value },
                  field: key,
                });
              } else {
                dispatch({
                  value,
                  field: key,
                });
              }
            }
          }
        } else {
          setpagestatus({
            edit: false,
            view: false,
            add: true,
          });
        }
      } else {
        console.log("inside else");

        Swal.fire({
          position: "center",
          icon: "error",
          title: "Cannot Fetch Company Try After Some Time",
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          nav("/dashboard");
        });
      }
    } catch (err) {
      console.log("inside catch");
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Cannot Fetch Company Try After Some Time",
        showConfirmButton: false,
        timer: 2500,
      }).then(() => {
        nav("/dashboard");
      });
    }
  };

  const create_or_edit_company = async () => {
    try {
      let statusremovedstate = removeStatusFields(state);
      console.log(statusremovedstate, "statusremovedstate");

      let createcompany = pagestatus.add;
      let updatedcontactinfo = statusremovedstate.contactInfo.map((info) => ({
        ...info,
        salutation: info?.salutation?.value,
      }));
      let updatedstate = {
        ...(pagestatus?.edit ? { id: company?.id } : {}),
        input: {
          ...statusremovedstate,
          country: statusremovedstate?.country?.value,
          city: statusremovedstate?.city?.value,
          state: statusremovedstate?.state?.value,
          ownershipType: statusremovedstate?.ownershipType?.value,
          contactInfo: updatedcontactinfo,
        },
      };

      //create
      const res = await apicall(
        createcompany ? addcompany : updatecompany,
        updatedstate
      );

      if (res.success) {
        const message = pagestatus?.add
          ? res.data.data.addCompany.message
          : res.data.data.updateCompany.message;
        const success = pagestatus?.add
          ? res.data.data.addCompany.success
          : res.data.data.updateCompany.success;
        Swal.fire({
          position: "center",
          icon: success ? "success" : "error",
          title: message,
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          nav("/company");
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Cannot Able to Create or Update",
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          nav("/company");
        });
      }
    } catch (err) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Cannot Able to Create or Update",
        showConfirmButton: false,
        timer: 2500,
      }).then(() => {
        nav("/company");
      });
    }
  };

  const verifyifsccode = async () => {
    if (state.ifscCode) {
      apicall(verifyifsc, { ifscCode: state.ifscCode })
        .then((res) => {
          console.log(res, "fetched ifsc");

          let success = res?.data?.data?.checkIfscCode?.success;
          let data = null;
          if (success) {
            data = res?.data?.data?.checkIfscCode?.data;
            let branch = data?.BRANCH;
            let address = data?.ADDRESS;
            let state = data?.STATE;
            setIFSCmessages(branch + " " + address + " " + state);
          } else {
            setIFSCmessages("IFSC Not verified");
          }
          // setsnackbar({
          //   open:true,
          //   message:success?"Verified IFSC":"Not Verified IFSC",
          //   severity:success?"success":"error"
          // })
        })
        .catch((err) => setIFSCmessages("IFSC Not verified"));
    }
  };

  const removeStatusFields = (stateObj) => {
    const cleaned = {};

    for (const key in stateObj) {
      if (key.endsWith("Status")) continue;

      if (key === "contactInfo" && Array.isArray(stateObj[key])) {
        // Clean each contact object
        cleaned[key] = stateObj[key].map((contact) => {
          const newContact = {};
          for (const contactKey in contact) {
            if (!contactKey.endsWith("Status")) {
              newContact[contactKey] = contact[contactKey];
            }
          }
          return newContact;
        });
      } else {
        cleaned[key] = stateObj[key];
      }
    }

    return cleaned;
  };

  const DeleteCompany = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirm Delete",
      message: "Are You Sure You Want to delete The Company ?",
      showCancel: true,
      showConfirm: true,
      customSection: null,
      onConfirm: () =>
        apicall(deletecompany, { id: company?.id })
          .then((res) => {
            let success = res.data.data.deleteCompany.success;
            let message = res.data.data.deleteCompany.message;
            Swal.fire({
              position: "center",
              icon: success ? "success" : "error",
              title: message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              nav("/company");
            });
          })
          .catch((err) =>
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Cannot Able to delete! delete after Sometime",
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              nav("/company");
            })
          ),
      onCancel: () => {
        setConfirmationDialog((prev) => ({
          ...prev,
          open: false,
        }));
      },
    });
  };

  return (
    <DashboardLayout>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() =>
          setsnackbar({
            open: false,
            message: "",
            severity: "", // optionally reset severity
          })
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // nice placement
      >
        <Alert
          onClose={() =>
            setsnackbar({
              open: false,
              message: "",
              severity: "",
            })
          }
          severity={snackbar.severity || "info"} // success, error, warning, info
          variant="filled" // or "outlined"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={true}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      {!pagestatus.view ? (
        <Card>
          <CardHeader
            title={
              <>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      {pagestatus?.add ? "Add" : "Edit"} Company Details
                    </MaterialTypography>
                  </Stack>

                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) =>
                        item.component === "EditCompany" && item.can_access
                    ) &&
                    pagestatus.edit && (
                      <ButtonGroup
                        variant="outlined"
                        aria-label="Loading button group"
                      >
                        {/* Uncomment if delete button is needed */}
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          onClick={DeleteCompany}
                          startIcon={<DeleteIcon />}
                        >
                          Delete
                        </MaterialButton>
                      </ButtonGroup>
                    )}
                </Stack>
              </>
            }
          />
          <CardContent sx={{ minHeight: "55vh" }}>
            <MaterialBox>
              <Grid container spacing={1}>
                {/* section 1*/}
                <Grid size={{ xs: 5, sm: 4, lg: 7 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Company Name <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialInput
                    name="companyname"
                    // placeholder="eg. IT"
                    value={state?.companyName}
                    onChange={(e) =>
                      dispatch({
                        value: e.target.value,
                        field: "companyName",
                      })
                    }
                    error={state.companyNameStatus === "error"}
                    success={state.companyNameStatus === "success"}
                  />
                </Grid>

                <Grid size={{ xs: 5, sm: 4, lg: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Address1 <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialInput
                    name="address"
                    value={state?.address1}
                    onChange={(e) =>
                      dispatch({
                        value: e.target.value,
                        field: "address1",
                      })
                    }
                    error={state.address1Status === "error"}
                    success={state.address1Status === "success"}
                    multiline
                    rows={5}
                  />
                </Grid>

                <Grid size={{ xs: 5, sm: 4, lg: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Address2 <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialInput
                    name="address"
                    value={state?.address2}
                    onChange={(e) =>
                      dispatch({
                        value: e.target.value,
                        field: "address2",
                      })
                    }
                    error={state.address2Status === "error"}
                    success={state.address2Status === "success"}
                    multiline
                    rows={5}
                    disabled={togglePage.view === true ? true : false}
                  />
                </Grid>
                <Grid container size={{ xs: 12, sm: 12, lg: 12 }}>
                  <Grid size={{ xs: 5, sm: 4, lg: 3 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Country <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>

                    <MaterialSelect
                      name="country"
                      value={state?.country}
                      onChange={(e) =>
                        dispatch({
                          value: e,
                          field: "country",
                        })
                      }
                      options={Country.getAllCountries().map((value) => {
                        return {
                          value: value.name,
                          label: value.name,
                          isoCode: value.isoCode,
                          phonecode: value.phonecode,
                        };
                      })}
                      error={state.countryStatus === "error"}
                      success={state.countryStatus === "success"}
                      //   isDisabled={togglePage.view === true ? true : false}
                    />
                  </Grid>
                  <Grid size={{ xs: 5, sm: 4, lg: 3 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        State <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>

                    <MaterialSelect
                      name="state"
                      value={state?.state}
                      onChange={(e) =>
                        dispatch({
                          value: e,
                          field: "state",
                        })
                      }
                      options={State.getStatesOfCountry(
                        state?.country?.isoCode
                      ).map((value) => {
                        return {
                          value: value.name,
                          label: value.name,
                          isoCode: value.isoCode,
                          countryCode: value.countryCode,
                        };
                      })}
                      error={state?.stateStatus === "error"}
                      success={state.stateStatus === "success"}
                      //   isDisabled={togglePage.view === true ? true : false}
                    />
                  </Grid>
                  <Grid size={{ xs: 5, sm: 4, lg: 3 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        City <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>

                    <MaterialSelect
                      name="city"
                      value={state?.city}
                      onChange={(e) => {
                        dispatch({
                          value: e,
                          field: "city",
                        });
                      }}
                      options={City?.getCitiesOfState(
                        state?.state?.countryCode || "",
                        state?.state?.isoCode
                      ).map((value) => {
                        return {
                          value: value.name,
                          label: value.name,
                        };
                      })}
                      error={state?.cityStatus === "error"}
                      success={state?.cityStatus === "success"}
                      //   disabled={togglePage.view === true ? true : false}
                    />
                  </Grid>

                  <Grid size={{ xs: 5, sm: 4, lg: 3 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Pincode
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="address"
                      type="number"
                      value={state?.pincode}
                      onChange={(e) =>
                        dispatch({
                          value: e.target.value,
                          field: "pincode",
                        })
                      }
                      error={state.pincodeStatus === "error"}
                      success={state.pincodeStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                    />
                  </Grid>
                </Grid>

                {/* section 2 */}

                <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Ownershiptype <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>

                  <MaterialSelect
                    name="country"
                    value={state?.ownershipType}
                    onChange={(e) =>
                      dispatch({
                        value: e,
                        field: "ownershipType",
                      })
                    }
                    options={ownershiptypes}
                    error={state.ownershipTypeStatus === "error"}
                    success={state.ownershipTypeStatus === "success"}
                    //   isDisabled={togglePage.view === true ? true : false}
                  />
                </Grid>
                <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      GST
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={state?.gstNumber}
                    onChange={(e) =>
                      dispatch({
                        value: e.target.value,
                        field: "gstNumber",
                      })
                    }
                    error={state.gstNumberStatus === "error"}
                    success={state.gstNumberStatus === "success"}
                    disabled={togglePage.view === true ? true : false}
                  />
                </Grid>

                <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      CIN
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={state?.cinNumber}
                    onChange={(e) =>
                      dispatch({
                        value: e.target.value,
                        field: "cinNumber",
                      })
                    }
                    error={state.cinNumberStatus === "error"}
                    success={state.cinNumberStatus === "success"}
                    disabled={togglePage.view === true ? true : false}
                  />
                </Grid>
                {/* section 3 */}
                <Grid container spacing={1} size={{ xs: 12, md: 12, lg: 12 }}>
                  <Grid size={{ xs: 5, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Incorporate Date
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      type="date"
                      value={state?.incorporationDate}
                      onChange={(e) =>
                        dispatch({
                          value: e.target.value,
                          field: "incorporationDate",
                        })
                      }
                      error={state.incorporationDateStatus === "error"}
                      success={state.incorporationDateStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                    />
                  </Grid>
                  <Grid container size={{ xs: 12, md: 12, lg: 12 }}>
                    <Grid size={{ xs: 5, sm: 4, lg: 6 }}>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          IFSC
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        value={state?.ifscCode}
                        onChange={(e) =>
                          dispatch({
                            value: e.target.value,
                            field: "ifscCode",
                          })
                        }
                        error={state.ifscCodeStatus === "error"}
                        success={state.ifscCodeStatus === "success"}
                      />
                      <FormControl error>
                        <FormHelperText>{IFSCmessages}</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid
                      size={{ xs: 5, sm: 4, lg: 6 }}
                      sx={{ display: "flex" }}
                    >
                      <IconButton
                        onClick={verifyifsccode}
                        sx={{ color: "green" }}
                      >
                        <VerifiedOutlinedIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>

                {/* section 4 */}
                <Grid size={{ xs: 12, md: 12, lg: 12 }} container spacing={1}>
                  <Grid
                    size={{ xs: 12, md: 12, lg: 12 }}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <IconButton onClick={() => dispatch({ method: "add" })}>
                      <AddBoxIcon />
                    </IconButton>
                  </Grid>
                  {state.contactInfo.map((info, index) => (
                    <Grid
                      container
                      spacing={1}
                      key={index}
                      size={{ xs: 12, md: 12, lg: 12 }}
                      sx={{
                        border: "1px solid grey",
                        borderRadius: "20px",
                        padding: "20px",
                      }}
                    >
                      {state?.contactInfo?.length > 1 && (
                        <span
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          <IconButton
                            onClick={() => {
                              setConfirmationDialog({
                                open: true,
                                title: "Delete Confirmation",
                                message:
                                  "Are You Sure to Delete Contact info ?",
                                showCancel: true,
                                onConfirm: () => {
                                  dispatch({
                                    method: "delete",
                                    index,
                                    edit: pagestatus?.edit,
                                  });
                                  setConfirmationDialog((prev) => ({
                                    ...prev,
                                    open: false,
                                  }));
                                },
                                onCancel: () => {
                                  setConfirmationDialog((prev) => ({
                                    ...prev,
                                    open: false,
                                  }));
                                },
                              });
                            }}
                            sx={{ color: "red" }}
                          >
                            <DeleteOutlineIcon />
                          </IconButton>
                        </span>
                      )}
                      <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Salution <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>

                        <MaterialSelect
                          name="country"
                          value={info?.salutation}
                          onChange={(e) =>
                            dispatch({
                              value: e,
                              field: "contactInfo",
                              index,
                              arrayfield: "salutation",
                            })
                          }
                          options={salutions}
                          error={info.salutationStatus === "error"}
                          success={info.salutationStatus === "success"}
                          //   isDisabled={togglePage.view === true ? true : false}
                        />
                      </Grid>

                      <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Name <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>

                        <MaterialInput
                          value={info.name}
                          onChange={(e) =>
                            dispatch({
                              value: e.target.value,
                              field: "contactInfo",
                              index,
                              arrayfield: "name",
                            })
                          }
                          error={info.nameStatus === "error"}
                          success={info.nameStatus === "success"}
                          disabled={togglePage.view === true ? true : false}
                        />
                      </Grid>

                      <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Designation <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>

                        <MaterialInput
                          value={info.designation}
                          onChange={(e) =>
                            dispatch({
                              value: e.target.value,
                              field: "contactInfo",
                              index,
                              arrayfield: "designation",
                            })
                          }
                          error={info.designationStatus === "error"}
                          success={info.designationStatus === "success"}
                          disabled={togglePage.view === true ? true : false}
                        />
                      </Grid>

                      <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Phone Number<span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>

                        <MaterialInput
                          value={info.phoneNumber}
                          onChange={(e) =>
                            dispatch({
                              value: e.target.value,
                              field: "contactInfo",
                              index,
                              arrayfield: "phoneNumber",
                            })
                          }
                          error={info.phoneNumberStatus === "error"}
                          success={info.phoneNumberStatus === "success"}
                          disabled={togglePage.view === true ? true : false}
                        />
                      </Grid>

                      <Grid size={{ xs: 5, sm: 4, lg: 4 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Email <span style={{ color: "red" }}>*</span>
                          </MaterialTypography>
                        </MaterialBox>

                        <MaterialInput
                          value={info.email}
                          onChange={(e) =>
                            dispatch({
                              value: e.target.value,
                              field: "contactInfo",
                              index,
                              arrayfield: "email",
                            })
                          }
                          error={info.emailStatus === "error"}
                          success={info.emailStatus === "success"}
                          disabled={togglePage.view === true ? true : false}
                        />
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </MaterialBox>
          </CardContent>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {togglePage?.edit && (
              <>
                <MaterialButton variant="gradient" color="dark" onClick={""}>
                  Discard
                </MaterialButton>

                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={""}
                >
                  Update
                </MaterialButton>
              </>
            )}
            {AccessData &&
              Array.isArray(AccessData) &&
              AccessData.some(
                (item) =>
                  (item.component === "EditCompany" ||
                    item.component === "AddCompany") &&
                  item.can_access
              ) &&
              !togglePage?.view &&
              !togglePage?.edit && (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={create_or_edit_company}
                >
                  {pagestatus.add ? "Submit" : "Update"}
                </MaterialButton>
              )}
          </MaterialBox>
          {
            <MaterialSnackbar
              color="success"
              icon={<NotificationsIcon />}
              title="Message"
              content="You have been submitted successfully"
              // open={snackBar.Success}
              // close={() =>
              //   setSnackBar({
              //     success: false,
              //   })
              // }
            />
          }
        </Card>
      ) : (
        <ViewCompany
          AccessData={AccessData}
          setpagestatus={setpagestatus}
          data={company}
        />
      )}
    </DashboardLayout>
  );
};

export default AddCompany;
